import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";

const ContactView = props => {
    const { t } = useTranslation();
    return (
        <div>
            <h1>Kontakt</h1>
            {t('contact.text')}<br />
            <a href={`mailto:info@braille.training?subject=${t('contact.subject')}`}>{t('contact.send_mail')}</a>
        </div>
    )
}
export default ContactView